import { createFileRoute } from '@tanstack/react-router';
import { Field } from '@osd/ui/field';
import { Fieldset } from '@osd/ui/fieldset';
import { Input } from '@osd/ui/input';
import { Checkbox } from '@osd/ui/checkbox';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/fieldset — live docs for the `Fieldset` primitive.
 */
export const Route = createFileRoute('/ui/_layout/fieldset')({
  component: FieldsetPage,
});

function FieldsetPage() {
  return (
    <Stack gap={6}>
      <Section
        title="Fieldset"
        hint="native <fieldset> + <legend> — required for grouped controls a11y"
      >
        <Fieldset legend="Address">
          <Field label="Street">
            <Input name="street" />
          </Field>
          <Field label="City">
            <Input name="city" />
          </Field>
        </Fieldset>
      </Section>

      <Section
        title="Hint + disabled"
        hint="legendHint sits next to the legend; disabled propagates to every control inside"
      >
        <Stack gap={4}>
          <Fieldset
            legend="Notification preferences"
            legendHint="We never share your email with third parties."
          >
            <Checkbox name="weekly" label="Weekly digest" defaultChecked />
            <Checkbox name="mentions" label="When someone mentions me" />
          </Fieldset>
          <Fieldset legend="Locked settings" disabled>
            <Field label="Email">
              <Input name="email" defaultValue="admin@bugfix.pro" />
            </Field>
            <Field label="Display name">
              <Input name="displayName" defaultValue="Kevin" />
            </Field>
          </Fieldset>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Basic group"
            language="tsx"
            code={`<Fieldset legend="Address">
  <Field label="Street">
    <Input name="street" />
  </Field>
  <Field label="City">
    <Input name="city" />
  </Field>
</Fieldset>`}
          />

          <CodeBlock
            title="With ErrorSummary above"
            hint="GOV.UK pattern — list every error above the form, then render the form"
            language="tsx"
            code={`<ErrorSummary errors={items} />
<Fieldset legend="Account">
  <Field label="Email"><Input name="email" /></Field>
  <Field label="Password"><Input type="password" name="password" /></Field>
</Fieldset>`}
          />

          <CodeBlock
            title="legendHint + disabled"
            language="tsx"
            code={`<Fieldset
  legend="Notification preferences"
  legendHint="We never share your email with third parties."
>
  <Checkbox name="weekly" label="Weekly digest" defaultChecked />
  <Checkbox name="mentions" label="When someone mentions me" />
</Fieldset>

<Fieldset legend="Locked settings" disabled>
  <Field label="Email"><Input name="email" /></Field>
  <Field label="Display name"><Input name="displayName" /></Field>
</Fieldset>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
